export default "__VITE_ASSET__AmNsE4X3__"